import { SharedCartOrganization } from '@/modules/cart/shared/types';
import { BaseState } from '@/store/base-state';
import { TableFilterItem, TableOptions } from '@/types';
import { default_new_order, default_order_details, update_delivery_details } from '../services';
import { Orders } from '../types';

export default class OrderState extends BaseState {
  new_order: Orders.Order = default_new_order();
  created_order: Orders.CreateOrderResponse = {
    cart_id: null,
    price: 0,
    total_order_price: 0,
    has_zip_products: false,
    no_order_products: [],
    no_order_products_count: 0,
    message: null,
  };

  is_clear_field = false;

  order_organizations: SharedCartOrganization[] = [];
  // for orders page
  new_delivery_details: Orders.OrderDeliveryUpdated = update_delivery_details();
  items: Orders.Item[] = [];
  order_details: Orders.OrderDetailedInfo = default_order_details();
  order_documents: Orders.OrderDocument[] = [];
  order_history_logs: Orders.OrderHistoryLog[] = [];
  cancel_reasons: Orders.OrderCancelReasons[] = [];
  loading = false;
  order_button_loading = false;

  is_cart_loaded = false

  cancel_order_dialog: Orders.CancelResonDialog = {
    visible: false,
    cancel_reason_id: 0,
  }

  last_order_info: Orders.LastCardType = {
    id: 0,
    organization_id: 0,
    payment_type: {
      id: 0,
      name: '',
      slug: '',
    },
    warehouse_id: null,
    delivery_type: {
      id: 0,
      name: '',
      slug: '',
    },
    self_delivery_type: {
      id: 0,
      name: '',
      slug: '',
    },
    delivery_address_id: 0,
    transport_company_id: 0,
    tc_delivery_type: '',
    is_express: false,
    tc_receiving_method: {
      id: 0,
      name: '',
      slug: '',
    },
  };

  additional: Orders.Additional = {
    total_price: 0,
  };

  filters: Orders.RequestFilters = {
    search: '',
    order_statuses: [],
    payment_type: null,
    dates: [],
    shipment_dates: [],
    organization: null,
    external_organization: null,
    contracts: [],
    users: [],
    shipment_statuses: [],
    is_unread_only: false,
    categories: [],
  };

  organizations: TableFilterItem[] = [];
  external_organizations: string[] = [];
  users: TableFilterItem[] = [];
  categories: TableFilterItem[] = [];
  contracts: TableFilterItem[] = [];
  statuses: TableFilterItem[] = [];
  shipment_statuses: TableFilterItem[] = [];
  payment_types: TableFilterItem[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['date'],
    sortDesc: [true],
  };

  shipment_orders_information: Orders.OrderShipment[] = [];

  shipment_orders_date: Orders.OrderItem[] = [];

  delivery_date = '';

  shipment_confirm_dialog = false;

  date_sent_success_modal = false;

  shipment_confirm_error = false;
  shipment_confirm_error_message = '';
  order_loading = false;
}
